import React from 'react';
import { ConfirmButton } from '../../../components/widgets/confirm-button';
import { Queue } from '../../../types/queue';

import { t } from '../../../locales/i18n';
import styled from 'styled-components';
import { sizes } from '../../../themes/sizes';
const Container = styled.section`
  display: grid;
  gap: ${sizes.margins.normal};
`;

export type QueueActionName = 'clearTickets' | 'reset' | 'forceOpen' | 'forceClose' | 'backToAutoOpening';
export interface QueueActionsProps {
  queue: Queue;
  onConfirm: (actionName: QueueActionName) => void;
}

export function QueueActions(props: QueueActionsProps) {
  const { queue, onConfirm } = props;

  return (
    <Container>
      <ConfirmButton
        basic
        negative
        label={t('clearTickets.label')}
        onConfirm={() => onConfirm('clearTickets')}
        title={t('clearTickets.title')}
        subtitle={t('clearTickets.subtitle')}
        confirmDisabled={!queue}
        primary
      ></ConfirmButton>
      <ConfirmButton
        basic
        negative
        label={t('resetQueue.label')}
        onConfirm={() => onConfirm('reset')}
        title={t('resetQueue.title')}
        subtitle={t('resetQueue.subtitle')}
        confirmDisabled={!queue}
        primary
      ></ConfirmButton>
      <ConfirmButton
        basic
        disabled={queue.status === 'open'}
        label={t('forceOpenQueue.label')}
        onConfirm={() => onConfirm('forceOpen')}
        title={t('forceOpenQueue.title')}
        subtitle={t('forceOpenQueue.subtitle')}
        confirmDisabled={!queue}
        primary
      ></ConfirmButton>
      <ConfirmButton
        basic
        disabled={queue.status === 'closed'}
        label={t('forceCloseQueue.label')}
        onConfirm={() => onConfirm('forceClose')}
        title={t('forceCloseQueue.title')}
        subtitle={t('forceCloseQueue.subtitle')}
        confirmDisabled={!queue}
        primary
      ></ConfirmButton>
      <ConfirmButton
        basic
        disabled={!queue.lockedManually}
        label={t('backToAutoOpening.label')}
        onConfirm={() => onConfirm('backToAutoOpening')}
        title={t('backToAutoOpening.title')}
        subtitle={t('backToAutoOpening.subtitle')}
        confirmDisabled={!queue}
        primary
      ></ConfirmButton>
    </Container>
  );
}
